import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PageTitle from '../../components/PageTitle';
import BlogList from '../../components/BlogList';

class Blog extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="page-with-title">
        <PageTitle title="Blog" />
        <div className="realm--page-for-copy">
          <BlogList
            categories={[17]}
            count={20}
            grid
            language={this.props.locale || 'en'}
            title=""
            view="card"
          />
        </div>
      </div>
    );
  }
}

Blog.propTypes = {
  locale: PropTypes.string
};

export default Blog;
